import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageBanner from '../components/PageBanner';
import Reveal from '../components/ui/Reveal';
import usePage from '../hooks/usePage';
import { useState, useEffect } from 'react';
import API from '../api/axios';

const DEFAULT_CONTENT = "<p class=\"italic text-primary text-[16px] md:text-[18px] leading-relaxed font-medium\">&quot;By education, I mean an all-around drawing of the best in child and man in body, mind, and spirit.&quot;</p>\n<p>At St. Andrews World School, Siddharth Vihar, we focus on the development of the child as a whole. Education is not merely about acquiring knowledge; it is about nurturing the body, mind, and spirit to create well-rounded individuals who are ready to take on the world.</p>\n<p>We believe that every child is unique and possesses immense potential. Our role as educators is to create an environment where this potential can be discovered and nurtured. Through a blend of academic rigor, creative exploration, physical development, and moral education, we ensure that our students grow into confident, compassionate, and capable individuals.</p>\n<p>Our dedicated faculty works tirelessly to create engaging learning experiences that go beyond textbooks. We encourage our students to ask questions, think critically, and develop a lifelong love for learning. The foundation years are crucial, and we ensure that each child receives the personalized attention they deserve.</p>\n<p>I warmly invite you to visit our campus and experience the nurturing environment we have created at St. Andrews World School, Siddharth Vihar. Together, let us embark on this beautiful journey of learning and growth.</p>\n<p class=\"text-white/90 italic leading-relaxed\">&quot;Education is the most powerful weapon which you can use to change the world.&quot; – Nelson Mandela</p>";

const PrincipalMessage = () => {
  const pageData = usePage('principals-message', { content: DEFAULT_CONTENT });
  const [sectionData, setSectionData] = useState({});

  useEffect(() => {
    API.get('/home-sections').then(res => {
      if (res.data?.data) setSectionData(res.data.data);
    }).catch(console.error);
  }, []);

  const pInfo = sectionData.principal_info || {};
  const principalName = pInfo.name || 'Shuchi Sood';
  const principalDesignation = pInfo.designation || 'Principal';
  const principalKicker = pInfo.kicker || "Principal's Desk";


  return (
    <>
      <SEO title="Principal's Message" description="Message from the Principal of St. Andrews World School, Siddharth Vihar — a word about our vision, values, and commitment to holistic education." keywords="Principal Message, Principal SAWS Siddharth Vihar, Shuchi Sood, St Andrews Principal" />
      <PageBanner title={pageData.banner_heading || "Principal's Message"} subtitle={pageData.banner_sub_heading || "A word from our Principal, Ms. Shuchi Sood"} breadcrumbs={[{ label: 'Home', link: '/' }, { label: pageData.title || "Principal's Message" }]} backgroundImage={pageData.bannerImage} fallback={`${process.env.PUBLIC_URL}/images/page-banners/principal-message.jpg`} loading={pageData.loading} />

      <section className="section bg-white">
        <div className="container">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12 items-start">
            {/* Principal Image */}
            <div className="lg:col-span-5">
              <Reveal>
                <div className="relative rounded-2xl overflow-hidden shadow-lg border border-gray-100">
                  <img
                    src={pageData.featuredImage || `${process.env.PUBLIC_URL}/images/principal.jpeg`}
                    alt="Principal Shuchi Sood"
                    className="w-full h-[520px] object-cover"
                    loading="eager"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary/40 via-transparent to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <div className="font-display text-xl font-semibold">{principalName}</div>
                    <div className="text-white/80 text-sm">{principalDesignation}</div>
                  </div>
                </div>
              </Reveal>
            </div>

            {/* Content */}
            <div className="lg:col-span-7">
              <Reveal>
                <div className="kicker">{principalKicker}</div>
                <div className="divider-line mt-5 !ml-[10px] !mr-auto" />
              </Reveal>

              <div className="mt-6 space-y-5 text-body text-[15px] md:text-[16px] leading-[1.7]" dangerouslySetInnerHTML={{ __html: pageData.content || DEFAULT_CONTENT }} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrincipalMessage;
